import React from 'react';
import Container from '../Components/Pages/HelpDetails/Container';
import Header from '../Components/Shared/Header/Header';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
function HelpDetails(){
    return(
        <>
        <Header styles="scrolled" />
        <Container />
        <Start />
        <Footer />
        </>
    )
};
export default HelpDetails;